// extracted by mini-css-extract-plugin
export default {"container":"anchor_container__Eai++","show":"anchor_show__7TKqh","nearBottom":"anchor_nearBottom__rqDmX","icon":"anchor_icon__C2Lj+"};